module.exports = __webpack_public_path__ + "static/media/Stackers-mb-fr.02ac2ca1.jpg";